import Axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import Vue from "vue";

export const createAxiosInstance = (config: AxiosRequestConfig = {}): AxiosInstance => {
    const axios = Axios.create({
        baseURL: process.env.VUE_APP_API_BASE,
        ...config,
    });

    axios.interceptors.request.use(
        async function (config) {
            // Add our Okta JWT

            if (!config.headers) config.headers = {};
            config.headers.authorization = `bearer ${await Vue.prototype.$auth.getAccessToken()}`;

            return config;
        },
        function (error) {
            return Promise.reject(error);
        },
    );

    return axios;
};
